module.exports = __webpack_public_path__ + "static/media/img-unemployment.4c5bd9af.png";